import AddIcon from "@material-ui/icons/Add";
import React, { useEffect, useState } from "react";
import FlexWrapper from "../../components/FlexWrapper";
import TableChartIcon from "@material-ui/icons/TableChart";
import Button from "../../components/@setproduct-ui/core/Button";
import { IconButton, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import DoneIcon from "@material-ui/icons/Done";
import { makeStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import { data } from "../HomePage/data";

const useStyles = makeStyles({
  root: {
    height: 116,
    flexGrow: 1,
    maxWidth: 400,
  },
});

function Input(props) {
  const [value, setValue] = useState(props.value);
  return (
    <input
      value={value}
      style={{ border: "none", width: "100px" }}
      onChange={e => setValue(e.target.value)}
      onBlur={props.onBlur}
    />
  )
}

function AnnotationTable(props) {
  const classes = useStyles();
  //   const [isOpen, setIsOpen] = useState(false);
  const [origTitle, setOrigTitle] = useState("Tabel Baru");
  const [expanded, setExpanded] = useState([]);
  const [selected, setSelected] = useState(null);

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeId) => {
    setSelected(nodeId);
    props.handleEdit(nodeId);
  };

  return (
    <div style={{ overflowY: "scroll", height: "75vh" }}>
      <FlexWrapper
        flexFlow="column"
        justifyContent="flex-start"
        alignItems="stretch"
        style={{
          fontSize: 12,
          padding: "10px",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      >
        <FlexWrapper>
          <TableChartIcon fontSize="small" style={{ marginRight: "5px" }} />
          Tables
        </FlexWrapper>
        <FlexWrapper>
          <Skeleton
            variant="circle"
            animation={false}
            width={30}
            height={30}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "3px",
            }}
          >
            {props.dataAnnotationTable.length}
          </Skeleton>
          <IconButton onClick={props.handleAdd} disableRipple size="small">
            <AddIcon />
          </IconButton>
        </FlexWrapper>
      </FlexWrapper>
      <React.Fragment>
        <TreeView
          className={classes.root}
          expanded={expanded}
          selected={[selected]}
          onNodeToggle={handleToggle}
          onNodeSelect={handleSelect}
        >
          {props.dataAnnotationTable.map((item, id) => (
            <TreeItem
              key={item._id || 'new'}
              nodeId={`${item._id}`}
              label={
                <FlexWrapper
                  flexFlow="column"
                  justifyContent="flex-start"
                  alignItems="stretch"
                  style={{
                    fontSize: 12,
                    padding: "10px",
                    justifyContent: "space-around",
                    flexDirection: "row",
                  }}
                >
                  {props.isEdit && props.editId === `${item._id}` ? (
                    <FlexWrapper
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        height: "30px",
                      }}
                    >
                      <Input value={item.title} onBlur={(e) => props.handleChange(item._id, e.target.value)} />
                      <IconButton
                        size="small"
                        onClick={() => {
                          props.setIsEdit(false);
                          props.setEditId(0);
                        }}
                      >
                        <DoneIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          props.handleCancel(item._id, origTitle)
                          setOrigTitle("")
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </FlexWrapper>
                  ) : (
                    <FlexWrapper
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        height: "30px",
                      }}
                    >
                      <Typography style={{ width: "100px", fontSize: "12px" }}>
                        {item.title}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          props.handleEdit(item._id);
                          setOrigTitle(item.title);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => props.handleDelete(item._id)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </FlexWrapper>
                  )}
                  <Button
                    type="icon"
                    fill={true}
                    color="primary"
                    view={item.title === "Tabel Baru" ? "smooth" : undefined}
                    onClick={props.enableCanvas}
                    disabled={item.title === "Tabel Baru" ? true : false}
                    icon="plus"
                  >
                    Select Area
                  </Button>
                </FlexWrapper>
              }
            >
              <TreeItem
                nodeId={`${item._id}.coordinates`}
                label={
                  <div>
                    <span>
                      selected ({item.coordinates[0].x?.toFixed(2)},{item.coordinates[0].y?.toFixed(2)}),(
                      {item.coordinates[1].x?.toFixed(2)},{item.coordinates[1].y?.toFixed(2)})
                    </span>
                  </div>
                }
              />
            </TreeItem>
          ))}
        </TreeView>
      </React.Fragment>
    </div>
  );
}

export default AnnotationTable;
